import React, { useState, useEffect, useRef } from 'react';
import { Host } from '../../../App';
import Axios from 'axios'
import Print from '../../../Common_Files/Print';
const InventoryReportTable = ({ Areas }) => {
  const [headers, setHeaders] = useState([]);
  const [filteredHeaders, setFilteredHeaders] = useState([]);
  const [filteredPostList, setFilteredPostList] = useState([]);
  const [postList, setpostList] = useState([]);
  var [Date1, setDate1] = useState(new Date());
  var [Postartdate, setPoStartdate] = useState(Date1.toISOString().slice(0, 10));
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  var token = (window.localStorage.getItem("acessToken"));
  const [Section, setSection] = useState("Flex");

  const tableRef = useRef(null);
  const [printTrigger, setPrintTrigger] = useState(false);
  const handlePrint = () => {
    const tableHTML = tableRef.current?.innerHTML;
    setPrintTrigger({ html: tableHTML });
  };

  const partfilters = {
    Start_date: Postartdate,
    End_date: Poenddate,
    token: token,
    Section: Section
  }

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/Pivot/Inventory`, { params: partfilters }).then((data) => {
      if (data.data === "Error") {
      }
      else {
        if (data.data[5].length > 0) {
          setpostList(data.data[5]);
        } else if (data.data[5].length <= 0) {
          window.alert("No Data Received!")
          setpostList([{
            "Description": " ",
            "QTY": "",
            "Receiving date": "",
          }]);
        }
      }
    })
  }, [Postartdate, Poenddate, Section])



  useEffect(() => {
    if (postList.length > 0) {
      // Extract all headers from the first item
      const allHeaders = Object.keys(postList[0]);
      setHeaders(allHeaders);

      // Identify zero columns (all values are zero)
      const zeroColumns = allHeaders.filter(header => {
        return header !== 'PART_NO' &&
          header !== 'PART_DESCRIPTION' &&
          header !== 'Internal_Part_No' &&
          postList.every(item =>
            item[header] === 0 ||
            item[header] === null ||
            item[header] === undefined
          );
      });

      // Filter headers and data
      const newFilteredHeaders = allHeaders.filter(header => !zeroColumns.includes(header));
      const newFilteredPostList = postList.map(item => {
        const newItem = { ...item };
        zeroColumns.forEach(col => delete newItem[col]);
        return newItem;
      });

      setFilteredHeaders(newFilteredHeaders);
      setFilteredPostList(newFilteredPostList);
    }
  }, [postList]);

  // Calculate totals for footer row
  const calculateTotals = () => {
    const totals = {};
    filteredHeaders.forEach(header => {
      if (header !== 'PART_NO' &&
        header !== 'PART_DESCRIPTION' &&
        header !== 'Internal_Part_No') {
        totals[header] = filteredPostList.reduce(
          (sum, item) => sum + (parseFloat(item[header]) || 0),
          0
        );
      }
    });
    return totals;
  };

  const totals = calculateTotals();

  // Format header display names
  const formatHeader = (header) => {
    if (header.endsWith('_QTY')) return header.replace('_QTY', '') + ' Qty';
    if (header.endsWith('_Required')) return header.replace('_Required', '') + ' Required';
    return header
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  };

  return (
    <div>
      <div class="row">
        <div class="col">
          <input type='date' class="form-control form-rounded" id='supplychain-button' defaultValue={Postartdate} onChange={(e) => {
            setPoStartdate(e.target.value)
          }} />
        </div>
        <div class="col">
          <input type='date' class="form-control form-rounded" id='supplychain-button' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => { setPoEnddate(e.target.value) }} />
        </div>
        <div className="col"><button className='btn btn-info' onClick={handlePrint}>Print</button></div>
        <div class="col d-flex justify-content-center my-3">
          <div class="border rounded p-4 bg-light shadow-sm" style={{ "min-width": "300px;" }}>
            <h6 class="text-center mb-3">Select Pivot Type</h6>
            <div class="form-check form-check-inline d-flex justify-content-between w-100">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Flex" onChange={(e) => { setSection(e.target.value) }} />
                <label class="form-check-label" for="inlineRadio1">Flex Pivot</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="Rigid" onChange={(e) => { setSection(e.target.value) }} />
                <label class="form-check-label" for="inlineRadio2">Rigid Pivot</label>
              </div>
            </div>
          </div>
        </div>

      </div>
      <br></br>
      <br></br>
      <div className="table-responsive" style={{ overflowX: 'auto' }}>
        <table className="table table-bordered table-striped" ref={tableRef}>
          <thead>
            <tr>
              {filteredHeaders.map(header => (
                <th key={header} className="header_table">
                  {formatHeader(header)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredPostList.map((post, index) => (
              <tr key={`${post.PART_NO}-${index}`}>
                {filteredHeaders.map(header => (
                  <td key={`${post.PART_NO}-${header}`}>
                    {header === 'PART_NO' ||
                      header === 'PART_DESCRIPTION' ||
                      header === 'Internal_Part_No' ? (
                      post[header]
                    ) : (
                      post[header] === 0 ? '' : post[header]
                    )}
                  </td>
                ))}
              </tr>
            ))}
            <tr className="Total">
              {filteredHeaders.map(header => {
                if (header === 'PART_NO') {
                  return <td key="total-label">Total</td>;
                }

                if (header === 'PART_DESCRIPTION' || header === 'Internal_Part_No') {
                  return <td key={`total-${header}`}></td>;
                }

                return (
                  <td key={`total-${header}`}>
                    {totals[header] === 0 ? '' : totals[header]}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
      {printTrigger && (
        <Print
          tableHTML={printTrigger.html}
          title={Areas}
          user="Vikas"
          onComplete={() => setPrintTrigger(false)}
        />
      )}
    </div>

  );
};

export default InventoryReportTable;